module.exports = __webpack_public_path__ + "img/noResult.44b55db1.png";